export const API_HOST = {
    local: 'http://localhost:4444/api/v1',
    development: 'http://18.195.90.100/api/v1',
    acceptance: 'http://18.195.90.100/api/v1',
    demo: 'https://clearem-demo.azurewebsites.net/api/v1',
    production: 'https://api.clearem.tv/api/v1'
};

export const ZOOM_LEVELS = [0.5, 0.75, 1, 1.5, 2, 3, 4];

export const LINEUP_TAB = 1;
export const TIMETABLE_REFRESH_TIME = 120000;

// CLEARING
export const CLEARING_TO_BE_CONFIRMED = 'to_be_confirmed';
export const CLEARING_LIMITED = 'limited';
export const CLEARING_YES = 'yes';

export const CLEARING_OPTIONS = [
    { value: CLEARING_TO_BE_CONFIRMED, label: 'To be confirmed' },
    { value: 'after_approval', label: 'After approval' },
    { value: CLEARING_LIMITED, label: 'Limited' },
    { value: 'no', label: 'No' },
    { value: CLEARING_YES, label: 'Yes' },
    { value: 'hidden', label: 'Hidden' }
];

// CONTRACTS
export const NO_SIGNERS_TEXT = 'No signers found.';
export const LOADING_TEXT = 'Loading...';
export const VALUE_ALL = 'all';

export const CONTRACT_STATE_SIGNED = 'signed';
export const CONTRACT_STATE_FEEDBACK = 'feedback';
export const CONTRACT_STATE_SENT = 'sent';
export const CONTRACT_STATE_SENT_DRAFT = 'sent_draft';
export const CONTRACT_STATE_NOT_FOUND = 'not_found';
export const CONTRACT_STATE_DRAFT = 'draft';
export const CONTRACT_STATE_REMINDER_SENT = 'reminder_sent';

export const CONTRACT_TYPES = {
    CLEARANCE: 'CLEARANCE',
    PERFORMANCE: 'PERFORMANCE'
};

export const CONTRACT_TYPE_OPTIONS = [
    { value: CONTRACT_TYPES.CLEARANCE, label: 'Clearance' },
    { value: CONTRACT_TYPES.PERFORMANCE, label: 'Performance' }
];

export const CONTRACT_STATE_OPTIONS = [
    { value: VALUE_ALL, label: 'All statusses' },
    { value: CONTRACT_STATE_DRAFT, label: 'Draft' },
    { value: CONTRACT_STATE_SENT_DRAFT, label: 'Ready for signing (Draft)' },
    { value: CONTRACT_STATE_SENT, label: 'Ready for signing' },
    { value: CONTRACT_STATE_FEEDBACK, label: 'Sent back' },
    { value: CONTRACT_STATE_SIGNED, label: 'Signed' }
];

export const CONTRACT_UPLOAD_STATES = [
    { value: CONTRACT_STATE_SENT, label: 'Sent' },
    { value: CONTRACT_STATE_SIGNED, label: 'Signed' }
];

export const CONTRACTS_INBOX_HEADERS = [
    {
        label: 'Event',
        key: 'eventName'
    },
    {
        label: 'Artist',
        key: 'artistName'
    },
    {
        label: 'Performances',
        key: 'performances'
    },
    {
        label: 'Last Modified',
        key: 'updatedAt'
    },
    {
        label: 'Status',
        key: 'state'
    }
];

export const LIST_VIEW_HEADERS = [
    {
        label: 'Artist',
        key: 'artistName'
    },
    { label: 'Stage', key: 'stageName' },
    { label: 'Performance Date', key: 'date' },
    { label: 'Live', key: 'clearing.live' },
    { label: 'Non Linear', key: 'clearing.nonLinear' },
    { label: 'Use until', key: 'clearing.useUntil' },
    { label: 'Comments', key: 'clearing.comments' }
];



// WEBPACK FOOTER //
// ./src/constants/settings.js